import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { IReservationSource } from './ReservationSourceModel'

type Props = {
  data: IReservationSource[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (item: IReservationSource) => void
  onDelete?: (item: IReservationSource) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ReservationSourceTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const columns: TableColumn<IReservationSource>[] = [
    { key: 'reservationSourceName', label: 'Rezervasyon Kaynağı', className: 'fw-semibold', sortable: true },
    { key: 'id', label: 'ID', sortable: true },
    { key: 'companyName', label: 'Cari Bilgi', sortable: true },
    { key: 'tariffType', label: 'Tarife', sortable: true },
  ]

  const actions: TableAction<IReservationSource>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (row) => onEdit?.(row),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (row) => onDelete?.(row),
    },
  ]
 

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz rezervasyon kaynağı bulunamadı'
    />
  )
}
